import { stringify } from 'querystring';
import { includes, isEmpty, omit, pick } from 'lodash-es';
import { getPageOrDefault } from '@is24at/react-pagination';
import { QUERY_DELIMITER } from '@is24at/react-constants';
import {
  ROUTE_RESULT_LIST_BASE_AUSTRIA_PATH,
  SearchParamsEnum,
} from 'utils/enums';
import sanitize from 'core/querySanitizer';

const canonicalUrl = ({ searchQuery, pathname }: any = {}) => {
  const ZIP_CODE_URL_PREFIX = 'plz-';
  const isFirstPage = getPageOrDefault(searchQuery) === 1;
  const sanitizedQuery = omit(
    searchQuery,
    sanitize(
      isFirstPage ? pick(searchQuery, [SearchParamsEnum.page]) : searchQuery,
    ),
    [
      SearchParamsEnum.region,
      SearchParamsEnum.spot,
      SearchParamsEnum.companyName,
      SearchParamsEnum.zipCode,
    ],
  );
  let formattedPathname = pathname;
  if (includes(pathname, ZIP_CODE_URL_PREFIX) && isFirstPage) {
    formattedPathname = ROUTE_RESULT_LIST_BASE_AUSTRIA_PATH;
  }
  return isEmpty(sanitizedQuery)
    ? formattedPathname
    : `${formattedPathname}${QUERY_DELIMITER}${stringify(sanitizedQuery)}`;
};

export default canonicalUrl;
